export default {
      id: "accessability-guide-usage",
      viewBox: "0 0 22 25",
      url: "/" + "sprite.svg#accessability-guide",
      toString: function () {
        return this.url;
      }
    }